import { GroupChannel } from '@sendbird/chat/groupChannel';

import { IDictionary } from '~/services/api/dictionaries/types';
import { IRole, ITeam } from '~/store/user/types';
import getChannelDataItem from './getChannelDataItem';
import getChannelTeams from './getChannelTeams';

interface IGetFilteredChannelsParams {
  channels: GroupChannel[];
  clinic?: IDictionary;
  team?: ITeam;
  role?: IRole;
  isGlobalUser: boolean;
}

const getFilteredChannels = ({
  channels,
  clinic,
  team,
  role,
  isGlobalUser,
}: IGetFilteredChannelsParams): GroupChannel[] =>
  channels.filter(channel => {
    const channelTeams: ITeam[] = getChannelTeams(channel.data);
    const channelClinicId: number | undefined = getChannelDataItem(channel.data, 'clinicId');

    if (channelClinicId && clinic?.id && channelClinicId !== clinic.id) {
      return false;
    }

    const globalUserTeams = role?.teams?.map(roleTeam => roleTeam.id) || [];
    const hasCommonTeam = channelTeams.some(chTeam => globalUserTeams.includes(chTeam.id));

    if (channelTeams.length && isGlobalUser && hasCommonTeam) {
      return true;
    }

    if (
      channelTeams.length &&
      team &&
      !channelTeams.some(channelTeam => channelTeam.id === team.id)
    ) {
      return false;
    }

    return true;
  });

export default getFilteredChannels;
